import React from "react";
import TopNavbar from "../../shares/TopNavbar";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-slate-100">
      <TopNavbar />
      <main className="mx-auto max-w-3xl px-4 py-10 sm:px-6 sm:py-16">
        <section className="rounded-3xl border border-slate-200 bg-white p-6 shadow-sm sm:p-10">
          <p className="text-sm font-semibold uppercase tracking-wide text-slate-500">
            404 Not Found
          </p>
          <h1 className="mt-3 text-3xl font-bold tracking-tight text-slate-950 sm:text-4xl">
            This page does not exist
          </h1>
          <p className="mt-4 text-lg text-slate-700">
            The URL you entered is not available in Fora Connector.
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <a
              href="/"
              className="inline-flex items-center justify-center rounded-xl bg-slate-950 px-5 py-3 text-base font-semibold text-white transition hover:bg-slate-900"
            >
              Go to dashboard
            </a>
            <a
              href="/signin"
              className="inline-flex items-center justify-center rounded-xl border border-slate-300 bg-white px-5 py-3 text-base font-semibold text-slate-700 transition hover:bg-slate-50"
            >
              Open access guide
            </a>
          </div>
        </section>
      </main>
    </div>
  );
}
